function FormsButtonTypeUserInfo(type) {
  
  switch (type) {
    case "Accept":
      return "تایید کردن";
    case "Reject":
      return "رد کردن";
    case "Inquire":
      return "استعلام هویت";
  
    default:
      return "";
  }
}
export default FormsButtonTypeUserInfo;
